

















import Vue from 'vue'
import RequirementItem from './RequirementItem.vue'

export default Vue.extend({
  name: 'license-requirements-block',
  components: { RequirementItem },
  props: {
    mech: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
  },
})
